import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import { store } from "../..";
import "../../assets/css/wibb/pages/tournaments.scss";
import Schedule from "../../components/Schedule";
import {
    selectSelectedTournament,
    tournamentManagementActions,
} from "../../features/tourneymgmt/tournamentManagementSlice";
import { getTournamentSchedule } from "../../lib/api";
import { isChildTournament } from "../../lib/utils";
import {
    IGame,
    IMasterTournamentSchedule,
    ITournamentSchedule,
} from "../../types/api";

export const loader = async ({ params }: any) => {
    store.dispatch(
        tournamentManagementActions.setselectedTournamentId(
            parseInt(params.tournamentId),
        ),
    );

    let tournaments = store.getState().tournamentmanagement.tournaments;
    let masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([tournamentsPromise, masterTournamentsPromise]);

    const tournamentId =
        store.getState().tournamentmanagement.selectedTournament;

    const tournament = selectSelectedTournament(store.getState());
    tournaments = store.getState().tournamentmanagement.tournaments;
    masterTournaments = store.getState().tournamentmanagement.masterTournaments;

    const isChild = isChildTournament(tournament);

    const masterTournament = isChild
        ? masterTournaments.find(
              mt =>
                  mt.id ===
                  tournaments.find(t => t.id === tournamentId)?.parent,
          )
        : tournament;

    const { schedule } = await getTournamentSchedule(params.tournamentId);

    const header = schedule
        ? isChild
            ? `${masterTournament?.name} - ${(schedule as ITournamentSchedule).ageLevel} Bracket Schedule`
            : `${tournament?.name} - All Bracket Schedules`
        : "Tournament Bracket Schedule";

    return {
        schedule,
        header,
    };
};

const TournamentPlayoffSchedule = (): React.JSX.Element => {
    const { schedule: loadedSchedule } = useLoaderData() as {
        schedule: ITournamentSchedule | IMasterTournamentSchedule;
    };

    const [schedule, setSchedule] = useState<IGame[]>([]);
    const [ageLevelGameIds, setAgeLevelGameIds] = useState<
        Record<string, number[]> | undefined
    >();

    useEffect(() => {
        if ("ageLevel" in loadedSchedule) {
            setSchedule(loadedSchedule.games || []);
        } else {
            setSchedule(
                loadedSchedule.games
                    .flatMap(i => i.games || [])
                    .sort(
                        (a, b) =>
                            new Date(a.date).getTime() -
                            new Date(b.date).getTime(),
                    ),
            );

            setAgeLevelGameIds(
                loadedSchedule.games.reduce(
                    (a, i) => {
                        if (i.games) {
                            a[i.ageLevel] = i.games.map(g => g.id);
                        }
                        return a;
                    },
                    {} as Record<string, number[]>,
                ),
            );
        }
    }, [loadedSchedule]);

    return (
        <div data-testid="tournamentScheduleContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        {schedule.length ? (
                            <Schedule
                                schedule={schedule?.filter(
                                    g => g.isPlayoff === 1,
                                )}
                                showButtons={true}
                                setSchedule={setSchedule}
                                scheduleHeader="Full Bracket Schedule"
                                scheduleType="tournament"
                                ageLevelGameIds={ageLevelGameIds}
                            />
                        ) : (
                            <h2>No scheduled bracket games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TournamentPlayoffSchedule;
